import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Collapse,
    FormControl,
    FormControlLabel,
    FormLabel,
    IconButton,
    InputAdornment,
    InputLabel,
    ListItemText,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Switch,
    TextField,
    Typography,
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { AddOutlined, CancelOutlined, ExpandMoreOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'
import { useSelector } from 'react-redux'

import { MainButton } from '../../../components'
import { TextAndSwitch } from '../../../components/Button/TextAndSwitch'
import { SubTitle, Title } from '../../../components/Cards/Common/Headers'
import StyledChip from '../../Common/StyledChip'
import { DeletableChip } from '../../../components/Misc/DeletableChip'
import { HiddenInput } from '../../../components/Misc/HiddenInput'
import {
    ACTIVE_INACTIVE_VALUES,
    BILLING_TYPE,
    BUCKET_TYPE,
    ENABLED_DISABLED_VALUES,
    MARKET_LAUNCH_STATES,
    MEM_TYPE_STATUSES,
    TRIAL_MEM_PROMO_TYPES,
} from '../../../utils'

const useStyles = makeStyles((theme) => ({
	header: {
		textDecoration: 'none'
	},

	fullWidthcard: {
		border: '1px solid #E5E5E5',
		boxShadow: 'none',
		width: '100%',
		marginBottom: 8
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	row: {
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
			// width: 270,
			minWidth: 270
		},
		'& .MuiSvgIcon-root': {
			color: '#3B0275',
			fill: '#3B0275'
		}
	},
	input: {
		marginBottom: theme.spacing(2),
		width: '32%'
		// marginRight: theme.spacing(2)
	},
	doubleSizeInput: {
		width: '66%'
	},
	fullWidth: {
		width: '100%'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 4
	},
	selectAdornment: {
		marginRight: theme.spacing(3)
	}
}))

const services = ['Daycare & Boarding', 'Bar & Park', 'Home Services', 'Grooming']

const AdvancedSettings = ({ selectedMarket, updateMarket, updateMembership, updateTrialMembership }) => {
	const classes = useStyles()
	const theme = useTheme()
	const facilities = useSelector((state) => state.specific.facilities.facilities)

	const [facs, setFacs] = useState([])
	const [isLaunchStateExpanded, setIsLaunchStateExpanded] = useState(false)

	useEffect(() => {
		if (selectedMarket && selectedMarket?._id && facilities && facilities.length) {
			let f = facilities.filter((f) => f.market_id == selectedMarket?._id)
			setFacs(f)
		}
	}, [facilities, selectedMarket])

	const marketOnStageTwo = selectedMarket?.phase === 'pre_launch_with_memberships'
	const marketOnStagesTwoTreeFour = [
		'pre_launch_with_memberships',
		'post_launch_limited_services',
		'fully_open'
	].includes(selectedMarket?.phase)
	const marketOnFinalStages = ['post_launch_limited_services', 'fully_open'].includes(selectedMarket?.phase)

	console.log('mems....', selectedMarket?.available_membership_types)

	return (
		<Card>
			<CardHeader title="Advanced Settings" />
			<CardContent>
				<Box className={classes.row}>
					<FormControl className={clsx([classes.input, classes.fullWidth])}>
						<InputLabel id="market-facilities">Facilities</InputLabel>
						<Select
							id="pets-select"
							variant="filled"
							value={facs}
							disabled={true}
							label="Pets"
							multiple
							renderValue={(facs) => (
								<div className={classes.chips}>
									{facs.map((value) => (
										<DeletableChip
											key={value._id}
											label={value.name}
											className={classes.chip}
										/>
									))}
								</div>
							)}></Select>
					</FormControl>

					<FormControl className={clsx([classes.input, classes.fullWidth])}>
						<InputLabel id="market-services">Services</InputLabel>
						<Select
							id="market-services-select"
							variant="filled"
							value={selectedMarket?.services || []}
							disabled={false}
							label="Pets"
							multiple
							onChange={(e) => {
								updateMarket('services', e.target.value)
							}}
							renderValue={(r) => (
								<div className={classes.chips}>
									{(selectedMarket?.services || []).map((value) => (
										<DeletableChip
											key={value}
											label={value}
											className={classes.chip}
											onDelete={() => {
												let s = (selectedMarket?.services || []).filter(
													(serv) => serv !== value
												)
												updateMarket('services', s)
											}}
										/>
									))}
								</div>
							)}>
							{services.map((v) => (
								<MenuItem key={v} value={v}>
									<Checkbox checked={(selectedMarket?.services || []).indexOf(v) > -1} />
									<ListItemText primary={v} />
								</MenuItem>
							))}
						</Select>
					</FormControl>

					{/*---------------------------- LAUNCH STATE + BULLETS ------------------------------ */}
					<SubTitle label="Launch State" />
					<Card className={classes.fullWidthcard}>
						<CardHeader
							className={classes.header}
							title="Launch State"
							onClick={() => setIsLaunchStateExpanded(!isLaunchStateExpanded)}
							action={
								<IconButton
									className={clsx(classes.expand, {
										[classes.expandOpen]: isLaunchStateExpanded
									})}
									onClick={() => setIsLaunchStateExpanded(!isLaunchStateExpanded)}
									aria-expanded={isLaunchStateExpanded}
									aria-label="show more">
									<ExpandMoreOutlined style={{ fill: '#777679' }} />
								</IconButton>
							}
						/>

						<Collapse in={isLaunchStateExpanded} timeout="auto" unmountOnExit>
							<CardContent>
								{/*---------------------------- LAUNCH STATE ------------------------------ */}
								<LaunchStateSection
									selectedMarket={selectedMarket}
									updateMarket={updateMarket}
									marketOnFinalStages={marketOnFinalStages}
								/>

								{/*---------------------------- BULLETS ------------------------------ */}
								{/* <CardHeader className={classes.header} title="Bullets" /> */}
								{!marketOnFinalStages && (
									<BulletsSection
										selectedMarket={selectedMarket}
										updateMarket={updateMarket}
										marketOnStageTwo={marketOnStageTwo}
									/>
								)}

								{/*---------------------------- FOUNDING TEXT BOX ------------------------------ */}
								{marketOnStagesTwoTreeFour && (
									<FoundingTextBoxSection
										selectedMarket={selectedMarket}
										updateMarket={updateMarket}
									/>
								)}
							</CardContent>
						</Collapse>
					</Card>

					{/*---------------------------- AVAILABLE MEMBERSHIPS ------------------------------ */}
					<SubTitle label="Available Memberships" />
					<Typography color="textSecondary">
						Membership catalogues are managed per facility. Open Facility Setup → Memberships for
						the facility you want to edit.
					</Typography>
				</Box>
			</CardContent>
		</Card>
	)
}

export const LaunchStateSection = ({ selectedMarket, updateMarket, marketOnFinalStages }) => {
	const classes = useStyles()

	return (
		<Box className={classes.row}>
			<FormControl className={classes.input}>
				<InputLabel id="market-launch-states">Launch State *</InputLabel>
				<Select
					variant="filled"
					value={selectedMarket?.phase || ''}
					disabled={false}
					onChange={(e) => {
						updateMarket('phase', e.target.value)
					}}>
					{Object.entries(MARKET_LAUNCH_STATES).map(([val, label]) => (
						<MenuItem key={val} value={val}>
							{label}
						</MenuItem>
					))}
				</Select>
			</FormControl>

			{marketOnFinalStages ? (
				<TextField
					className={clsx([classes.input, classes.fullWidth])}
					label="Basic Member Promo Text *"
					variant="filled"
					value={selectedMarket?.basic_member_promo_text}
					onChange={(e, v) => {
						e.preventDefault()
						updateMarket('basic_member_promo_text', e.target.value)
					}}
					helperText={`${selectedMarket?.basic_member_promo_text?.length || 0} / 200 Max Characters`}
					inputProps={{ maxLength: 200 }}
				/>
			) : (
				<Box className={classes.row}>
					<TextField
						className={classes.input}
						label="Header Text"
						variant="filled"
						required
						value={selectedMarket?.header_text}
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('header_text', e.target.value)
						}}
						helperText={`${selectedMarket?.header_text?.length || 0} / 35 Max Characters`}
						inputProps={{ maxLength: 35 }}
					/>
					<TextField
						className={clsx([classes.input, classes.doubleSizeInput])}
						label="Sub Header Text"
						variant="filled"
						required
						value={selectedMarket?.sub_header_text}
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('sub_header_text', e.target.value)
						}}
						helperText={`${selectedMarket?.sub_header_text?.length || 0} / 50 Max Characters`}
						inputProps={{ maxLength: 50 }}
					/>
				</Box>
			)}
		</Box>
	)
}

export const BulletsSection = ({ selectedMarket, updateMarket, marketOnStageTwo }) => {
	const classes = useStyles()

	return (
		<Box>
			<ListWithAddButton
				title="Bullets"
				list={selectedMarket?.bullets}
				label="Bullet"
				onChange={(list) => {
					updateMarket('bullets', list)
				}}
				onDelete={(list) => {
					updateMarket('bullets', list)
				}}
				onAdd={(list) => {
					updateMarket('bullets', list)
				}}
				maxCharacters={50}
				addButtonLabel="Bullet"
			/>
			<Box className={classes.row} style={{ paddingTop: 20 }}>
				<TextField
					className={clsx([classes.input])}
					label="Bullet Link Text"
					required
					variant="filled"
					value={selectedMarket?.bullet_link_text}
					onChange={(e, v) => {
						e.preventDefault()
						updateMarket('bullet_link_text', e.target.value)
					}}
					helperText={`${selectedMarket?.bullet_link_text?.length || 0} / 50 Max Characters`}
					inputProps={{ maxLength: 50 }}
				/>
				<TextField
					className={clsx([classes.input])}
					label="Bullet Link Click Path Text"
					required
					variant="filled"
					value={selectedMarket?.bullet_link_path}
					onChange={(e, v) => {
						e.preventDefault()
						updateMarket('bullet_link_path', e.target.value)
					}}
				/>
				<HiddenInput />

				<TextField
					className={clsx([classes.input])}
					label="Primary Button Text"
					required
					variant="filled"
					value={selectedMarket?.primary_button_text}
					onChange={(e, v) => {
						e.preventDefault()
						updateMarket('primary_button_text', e.target.value)
					}}
					helperText={`${selectedMarket?.primary_button_text?.length || 0} / 35 Max Characters`}
					inputProps={{ maxLength: 35 }}
				/>
				<TextField
					className={clsx([classes.input])}
					label="Primary Button Click Path"
					required
					variant="filled"
					value={selectedMarket?.primary_button_path}
					onChange={(e, v) => {
						e.preventDefault()
						updateMarket('primary_button_path', e.target.value)
					}}
				/>
				<HiddenInput />

				<TextField
					className={clsx([classes.input])}
					label="Secondary Button Text"
					required
					variant="filled"
					value={selectedMarket?.secondary_button_text}
					onChange={(e, v) => {
						e.preventDefault()
						updateMarket('secondary_button_text', e.target.value)
					}}
					disabled={!marketOnStageTwo}
					helperText={`${selectedMarket?.secondary_button_text?.length || 0} / 35 Max Characters`}
					inputProps={{ maxLength: 35 }}
				/>
				<TextField
					className={clsx([classes.input])}
					label="Primary Button Click Path"
					required
					variant="filled"
					value={selectedMarket?.secondary_button_path}
					disabled={!marketOnStageTwo}
					onChange={(e, v) => {
						e.preventDefault()
						updateMarket('secondary_button_path', e.target.value)
					}}
				/>
				<HiddenInput />
			</Box>
		</Box>
	)
}

export const FoundingTextBoxSection = ({ selectedMarket, updateMarket }) => {
	const classes = useStyles()

	return (
		<Box className={classes.row}>
			<Title label="Founding text box" />
			<TextAndSwitch
				text="Enable Founding Text Box"
				active={selectedMarket?.founding_text_box_enabled}
				setActive={(val) => updateMarket('founding_text_box_enabled', val)}
			/>

			{!!selectedMarket?.founding_text_box_enabled && (
				<Box className={classes.row}>
					<TextField
						className={clsx([classes.input])}
						label="Founding Title Text"
						required
						disabled={!selectedMarket?.founding_text_box_enabled}
						variant="filled"
						value={selectedMarket?.founding_text_box_title}
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('founding_text_box_title', e.target.value)
						}}
						helperText={`${selectedMarket?.founding_text_box_title?.length || 0} / 50 Max Characters`}
						inputProps={{ maxLength: 50 }}
					/>

					<HiddenInput />

					<TextField
						className={clsx([classes.input, classes.doubleSizeInput])}
						label="Founding Body Text"
						required
						disabled={!selectedMarket?.founding_text_box_enabled}
						multiline
						rows={4}
						variant="filled"
						value={selectedMarket?.founding_text_box_body}
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('founding_text_box_body', e.target.value)
						}}
						helperText={`${selectedMarket?.founding_text_box_body?.length || 0} / 200 Max Characters`}
						inputProps={{ maxLength: 200 }}
					/>

					<HiddenInput />

					<TextField
						className={clsx([classes.input])}
						label="Founding Link Text"
						// required
						disabled={!selectedMarket?.founding_text_box_enabled}
						variant="filled"
						value={selectedMarket?.founding_text_box_link_text}
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('founding_text_box_link_text', e.target.value)
						}}
						helperText={`${
							selectedMarket?.founding_text_box_link_text?.length || 0
						} / 50 Max Characters`}
						inputProps={{ maxLength: 50 }}
					/>

					<TextField
						className={clsx([classes.input])}
						label="Founding Link Click Path"
						// required
						disabled={!selectedMarket?.founding_text_box_enabled}
						variant="filled"
						value={selectedMarket?.founding_text_box_link_path}
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('founding_text_box_link_path', e.target.value)
						}}
						helperText={`${
							selectedMarket?.founding_text_box_link_path?.length || 0
						} / 200 Max Characters`}
						inputProps={{ maxLength: 200 }}
					/>

					<HiddenInput />
				</Box>
			)}
		</Box>
	)
}

// Status pill shown in a membership block's header, so status is visible without expanding
// the block. Variants follow the enrichment pills: active green, inactive gray, the rest yellow.
const MEMBERSHIP_STATUS_VARIANT = {
	active: 'successes',
	inactive: 'gray',
	secret: 'warnings',
	waitlist: 'warnings',
	sold_out: 'warnings'
}

const MembershipHeaderTitle = ({ membership }) => {
	const status = membership.status || 'inactive'
	const label = MEM_TYPE_STATUSES[status] || status

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
			<span>{`${membership.name} ${membership.billing_method ? `(${membership.billing_method})` : ''}`}</span>
			<StyledChip skiptownvariant={MEMBERSHIP_STATUS_VARIANT[status] || 'purple'} label={label} size="small" />
		</div>
	)
}

export const MembershipType = ({ membership, updateMembership }) => {
	const classes = useStyles()
	const theme = useTheme()
	const [isExpanded, setIsExpanded] = useState(false)

	const isInactive = () => membership.status === 'inactive'

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	return (
		<Card className={classes.fullWidthcard}>
			{/*---------------------------- AVAILABLE MEMBERSHIP ------------------------------ */}
			<CardHeader
				className={classes.header}
				title={<MembershipHeaderTitle membership={membership} />}
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, {
							[classes.expandOpen]: isExpanded
						})}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				{/* MEMBERSHIP INFO */}
				<CardContent>
					<SubTitle pt={0} label={'Membership Settings'} />
					<Box className={classes.row}>
						<FormControl className={classes.input} required>
							<InputLabel>Status</InputLabel>
							<Select
								required
								variant="filled"
								value={membership.status}
								disabled={false}
								onChange={(e) => {
									updateMembership(membership._id, 'status', e.target.value)
								}}>
								{Object.entries(MEM_TYPE_STATUSES).map(([val, label]) => (
									<MenuItem key={val} value={val}>
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<TextField
							className={clsx([classes.input])}
							label="Price"
							required
							disabled={isInactive()}
							// type="number"
							variant="filled"
							value={formatNumsToDollars(onlyNumbers(membership.price))}
							InputProps={{
								// startAdornment: <InputAdornment position="end">$</InputAdornment>
								endAdornment: <InputAdornment position="end">$</InputAdornment>
							}}
							onChange={(e, v) => {
								e.preventDefault()
								updateMembership(membership._id, 'price', parseInt(onlyNumbers(e.target.value)))
							}}
						/>

						<TextField
							className={clsx([classes.input])}
							label="Discount Amount"
							required
							disabled={isInactive()}
							// type="number"
							variant="filled"
							value={membership.discount ? (membership.discount * 100).toFixed() : ''}
							InputProps={{
								endAdornment: <InputAdornment position="end">%</InputAdornment>
							}}
							onChange={(e, v) => {
								e.preventDefault()
								let val = e.target.value
								console.log('val..', val)
								let num = 0
								if (val) {
									num = Number(onlyNumbers(e.target.value))
									// num = e.target.value
									num = (num / 100).toFixed(2)
								}

								console.log(num)

								updateMembership(membership._id, 'discount', num)
							}}
						/>

						<TextField
							className={clsx([classes.input])}
							label="Additional Dog Price"
							required
							disabled={isInactive()}
							// type="number"
							variant="filled"
							value={formatNumsToDollars(onlyNumbers(membership.additional_pet_fee))}
							InputProps={{
								// startAdornment: <InputAdornment position="end">$</InputAdornment>
								endAdornment: <InputAdornment position="end">$</InputAdornment>
							}}
							onChange={(e, v) => {
								e.preventDefault()
								updateMembership(
									membership._id,
									'additional_pet_fee',
									parseInt(onlyNumbers(e.target.value))
								)
							}}
						/>

						<TextField
							className={clsx([classes.input])}
							label="Activation Fee"
							disabled={isInactive()}
							variant="filled"
							value={formatNumsToDollars(onlyNumbers(membership.activation_fee))}
							InputProps={{
								endAdornment: <InputAdornment position="end">$</InputAdornment>
							}}
							onChange={(e) => {
								e.preventDefault()
								const raw = parseInt(onlyNumbers(e.target.value), 10)
								updateMembership(
									membership._id,
									'activation_fee',
									Number.isNaN(raw) ? 0 : raw
								)
							}}
						/>

						<FormControl className={classes.input} disabled={isInactive()}>
							<FormControlLabel
								control={
									<Switch
										color="primary"
										checked={membership.waive_activation_fee_first_joiners !== false}
										onChange={(e) =>
											updateMembership(
												membership._id,
												'waive_activation_fee_first_joiners',
												e.target.checked
											)
										}
									/>
								}
								label="Waive for first-time joiners"
								style={{ marginTop: 8 }}
							/>
						</FormControl>

						<FormControl className={classes.input} required disabled={isInactive()}>
							<FormLabel style={{ transform: 'unset' }}>Discount</FormLabel>
							<RadioGroup
								row
								aria-label="has_discount"
								name="has_discount1"
								value={!!membership.has_discount}
								onChange={() =>
									updateMembership(membership._id, 'has_discount', !membership.has_discount)
								}>
								<FormControlLabel value={true} control={<Radio />} label="Yes" />
								<FormControlLabel value={false} control={<Radio />} label="No" />
							</RadioGroup>
						</FormControl>

						<FormControl className={classes.input} required disabled={isInactive()}>
							<FormLabel style={{ transform: 'unset' }}>Founding Tag</FormLabel>
							<RadioGroup
								row
								aria-label="has_founding_tag"
								name="has_founding_tag1"
								value={!!membership.has_founding_tag}
								onChange={() =>
									updateMembership(
										membership._id,
										'has_founding_tag',
										!membership.has_founding_tag
									)
								}>
								<FormControlLabel value={true} control={<Radio color="primary" />} label="Yes" />
								<FormControlLabel value={false} control={<Radio color="primary" />} label="No" />
							</RadioGroup>
						</FormControl>

						<FormControl className={classes.input} required>
							<InputLabel>Billing Type</InputLabel>
							<Select
								required
								variant="filled"
								value={membership.billing_method}
								disabled
								onChange={(e) => {
									updateMembership(membership._id, 'billing_method', e.target.value)
								}}>
								{Object.entries(BILLING_TYPE).map(([val, label]) => (
									<MenuItem key={val} value={val}>
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<FormControl className={classes.input} required>
							<InputLabel>Bucket</InputLabel>
							<Select
								required
								variant="filled"
								value={membership.bucket}
								disabled
								onChange={(e) => {
									updateMembership(membership._id, 'bucket', e.target.value)
								}}>
								{Object.entries(BUCKET_TYPE).map(([val, label]) => (
									<MenuItem key={val} value={val}>
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<HiddenInput />

						<TextField
							className={clsx([classes.input, classes.fullWidth])}
							label="Description"
							required
							disabled={isInactive()}
							// type="number"
							variant="filled"
							value={membership.description || ''}
							onChange={(e, v) => {
								e.preventDefault()
								updateMembership(membership._id, 'description', e.target.value)
							}}
						/>
					</Box>

					{/* MEMBERSHIP PERKS */}
					<ListWithAddButton
						subtitle={'Membership Perks'}
						list={membership.benefits}
						label="Perk"
						onChange={(list) => {
							updateMembership(membership._id, 'benefits', list)
						}}
						onDelete={(list) => {
							updateMembership(membership._id, 'benefits', list)
						}}
						onAdd={(list) => {
							updateMembership(membership._id, 'benefits', list)
						}}
						maxCharacters={150}
						addButtonLabel="Perk"
					/>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export const TrialMembershipType = ({ membership, updateMembership, updateTrialMembership }) => {
	const classes = useStyles()
	const theme = useTheme()
	const [isExpanded, setIsExpanded] = useState(false)

	const isInactive = () => membership.status !== 'active'
	const isAnnualPromoInactive = () => membership.trial_settings?.annual_promotion !== 'active'
	const isMonthlyPromoInactive = () => membership.trial_settings?.monthly_promotion !== 'active'

	useEffect(() => {
		if (isExpanded && membership.trial_settings?.annual_promotion_type)
			updateTrialMembership(membership._id, 'annual_promotion_details', '')
	}, [membership.trial_settings?.annual_promotion_type])

	useEffect(() => {
		if (isExpanded && membership.trial_settings?.monthly_promotion_type)
			updateTrialMembership(membership._id, 'monthly_promotion_details', '')
	}, [membership.trial_settings?.monthly_promotion_type])

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	if (!membership.is_trial) return

	return (
		<Card className={classes.fullWidthcard}>
			{/*---------------------------- AVAILABLE MEMBERSHIP ------------------------------ */}
			<CardHeader
				className={classes.header}
				title={<MembershipHeaderTitle membership={membership} />}
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, {
							[classes.expandOpen]: isExpanded
						})}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				{/* MEMBERSHIP INFO */}
				<CardContent>
					<SubTitle pt={0} label={'Trial Settings'} />
					<Box className={classes.row}>
						<FormControl className={classes.input} required>
							<InputLabel>Status</InputLabel>
							<Select
								required
								variant="filled"
								value={membership.status}
								disabled={false}
								onChange={(e) => {
									updateMembership(membership._id, 'status', e.target.value)
								}}>
								{Object.entries(ACTIVE_INACTIVE_VALUES).map(([val, label]) => (
									<MenuItem key={val} value={val}>
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<TextField
							className={clsx([classes.input])}
							type="number"
							label="Trial Length"
							required
							disabled={isInactive()}
							// type="number"
							variant="filled"
							value={membership.trial_settings?.trial_length}
							InputProps={{
								// startAdornment: <InputAdornment position="end">$</InputAdornment>
								endAdornment: <InputAdornment position="end">days</InputAdornment>
							}}
							onChange={(e, v) => {
								e.preventDefault()
								const val = e.target.value || undefined
								if (val === undefined || (val >= 0 && val < 100))
									updateTrialMembership(membership._id, 'trial_length', val)
							}}
						/>

						<FormControl className={classes.input} required>
							<InputLabel>Auto-Enrollment</InputLabel>
							<Select
								required
								variant="filled"
								value={membership.trial_settings?.auto_enrollment}
								disabled={isInactive()}
								onChange={(e) => {
									updateTrialMembership(membership._id, 'auto_enrollment', e.target.value)
								}}>
								{Object.entries(ENABLED_DISABLED_VALUES).map(([val, label]) => (
									<MenuItem key={val} value={val}>
										{label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>

					{/* MEMBERSHIP PERKS */}
					<ListWithAddButton
						subtitle={'Trial Perks'}
						list={membership.benefits}
						disabled={isInactive()}
						label="Perk"
						onChange={(list) => {
							updateMembership(membership._id, 'benefits', list)
						}}
						onDelete={(list) => {
							updateMembership(membership._id, 'benefits', list)
						}}
						onAdd={(list) => {
							updateMembership(membership._id, 'benefits', list)
						}}
						maxCharacters={150}
						addButtonLabel="Perk"
					/>

					<SubTitle label={'Trial Promotion'} />
					<Box mb={1.5}>
						<Title pt={0} fontSize={12} label={'Annual Promo'} />
						<Box className={classes.row}>
							<FormControl className={classes.input} required>
								<InputLabel>Annual Promotion</InputLabel>
								<Select
									required
									variant="filled"
									value={membership.trial_settings?.annual_promotion}
									disabled={isInactive()}
									onChange={(e) => {
										updateTrialMembership(membership._id, 'annual_promotion', e.target.value)
									}}>
									{Object.entries(ACTIVE_INACTIVE_VALUES).map(([val, label]) => (
										<MenuItem key={val} value={val}>
											{label}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<FormControl className={classes.input} required>
								<InputLabel>Annual Promotion Type</InputLabel>
								<Select
									required={!isAnnualPromoInactive()}
									variant="filled"
									value={membership.trial_settings?.annual_promotion_type}
									disabled={isAnnualPromoInactive() || isInactive()}
									onChange={(e) => {
										updateTrialMembership(
											membership._id,
											'annual_promotion_type',
											e.target.value
										)
									}}>
									{Object.entries(TRIAL_MEM_PROMO_TYPES).map(([val, label]) => (
										<MenuItem key={val} value={val}>
											{label}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							{membership.trial_settings?.annual_promotion_type === 'free_months' ? (
								<TextField
									className={clsx([classes.input])}
									type="number"
									label="Annual Promotion Details"
									required
									disabled={isAnnualPromoInactive() || isInactive()}
									// type="number"
									variant="filled"
									value={membership.trial_settings?.annual_promotion_details}
									InputProps={{
										// startAdornment: <InputAdornment position="end">$</InputAdornment>
										endAdornment: (
											<InputAdornment className={classes.selectAdornment} position="end">
												Month(s)
											</InputAdornment>
										)
									}}
									select={true}
									onChange={(e, v) => {
										e.preventDefault()
										updateTrialMembership(
											membership._id,
											'annual_promotion_details',
											e.target.value
										)
									}}>
									{[1, 2, 3, 4, 5, 6].map((val) => (
										<MenuItem key={val} value={val}>
											{val}
										</MenuItem>
									))}
								</TextField>
							) : membership.trial_settings?.annual_promotion_type === 'discount' ? (
								<TextField
									className={clsx([classes.input])}
									type="number"
									label="Annual Promotion Details"
									required
									disabled={isAnnualPromoInactive() || isInactive()}
									variant="filled"
									value={membership.trial_settings?.annual_promotion_details}
									InputProps={{
										// startAdornment: <InputAdornment position="end">$</InputAdornment>
										endAdornment: <InputAdornment position="end">%</InputAdornment>,
										inputProps: { min: 1, max: 100 }
									}}
									helperText={'Annual Promotion Details must be 1-100.'}
									onChange={(e, v) => {
										e.preventDefault()
										if (e.target.value >= 0 && e.target.value <= 100)
											updateTrialMembership(
												membership._id,
												'annual_promotion_details',
												e.target.value
											)
									}}
								/>
							) : (
								<TextField
									className={clsx([classes.input])}
									label="Annual Promotion Details"
									required
									disabled={isAnnualPromoInactive() || isInactive()}
									variant="filled"
									value={membership.trial_settings?.annual_promotion_details}
									InputProps={{
										// startAdornment: <InputAdornment position="end">$</InputAdornment>
										// endAdornment: <InputAdornment position="end">Month(s)</InputAdornment>,
										inputProps: { maxLength: 15 }
									}}
									onChange={(e, v) => {
										e.preventDefault()
										updateTrialMembership(
											membership._id,
											'annual_promotion_details',
											e.target.value
										)
									}}
									helperText={`${
										membership.trial_settings?.annual_promotion_details
											? membership.trial_settings?.annual_promotion_details.length
											: 0
									} / 15 Max Characters`}
									inputProps={{ maxLength: 15 }}
								/>
							)}
						</Box>
					</Box>

					<Box mb={1.5}>
						<Title pt={0} fontSize={12} label={'Monthly Promo'} />
						<Box className={classes.row}>
							<FormControl className={classes.input} required>
								<InputLabel>Monthly Promotion</InputLabel>
								<Select
									required
									variant="filled"
									value={membership.trial_settings?.monthly_promotion}
									disabled={isInactive()}
									onChange={(e) => {
										updateTrialMembership(membership._id, 'monthly_promotion', e.target.value)
									}}>
									{Object.entries(ACTIVE_INACTIVE_VALUES).map(([val, label]) => (
										<MenuItem key={val} value={val}>
											{label}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<FormControl className={classes.input} required>
								<InputLabel>Monthly Promotion Type</InputLabel>
								<Select
									required={!isMonthlyPromoInactive()}
									variant="filled"
									value={membership.trial_settings?.monthly_promotion_type}
									disabled={isMonthlyPromoInactive() || isInactive()}
									onChange={(e) => {
										updateTrialMembership(
											membership._id,
											'monthly_promotion_type',
											e.target.value
										)
									}}>
									{Object.entries(TRIAL_MEM_PROMO_TYPES).map(([val, label]) => (
										<MenuItem key={val} value={val}>
											{label}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							{membership.trial_settings?.monthly_promotion_type === 'free_months' ? (
								<TextField
									className={clsx([classes.input])}
									type="number"
									label="Monthly Promotion Details"
									required
									disabled={isMonthlyPromoInactive() || isInactive()}
									variant="filled"
									value={membership.trial_settings?.monthly_promotion_details}
									InputProps={{
										// startAdornment: <InputAdornment position="end">$</InputAdornment>
										endAdornment: (
											<InputAdornment className={classes.selectAdornment} position="end">
												Month(s)
											</InputAdornment>
										)
									}}
									select={true}
									onChange={(e, v) => {
										e.preventDefault()
										updateTrialMembership(
											membership._id,
											'monthly_promotion_details',
											e.target.value
										)
									}}>
									{[1, 2, 3].map((val) => (
										<MenuItem key={val} value={val}>
											{val}
										</MenuItem>
									))}
								</TextField>
							) : membership.trial_settings?.monthly_promotion_type === 'discount' ? (
								<TextField
									className={clsx([classes.input])}
									type="number"
									label="Monthly Promotion Details"
									required
									disabled={isMonthlyPromoInactive() || isInactive()}
									variant="filled"
									value={membership.trial_settings?.monthly_promotion_details}
									InputProps={{
										// startAdornment: <InputAdornment position="end">$</InputAdornment>
										endAdornment: <InputAdornment position="end">%</InputAdornment>,
										inputProps: { min: 1, max: 100 }
									}}
									helperText={'Monthly Promotion Details must be 1-100.'}
									onChange={(e, v) => {
										e.preventDefault()
										if (e.target.value >= 0 && e.target.value <= 100)
											updateTrialMembership(
												membership._id,
												'monthly_promotion_details',
												e.target.value
											)
									}}
								/>
							) : (
								<TextField
									className={clsx([classes.input])}
									type="string"
									label="Monthly Promotion Details"
									required
									disabled={isMonthlyPromoInactive() || isInactive()}
									variant="filled"
									value={membership.trial_settings?.monthly_promotion_details}
									InputProps={{
										// startAdornment: <InputAdornment position="end">$</InputAdornment>
										// endAdornment: <InputAdornment position="end">Month(s)</InputAdornment>,
										inputProps: { maxLength: 15 }
									}}
									onChange={(e, v) => {
										e.preventDefault()
										updateTrialMembership(
											membership._id,
											'monthly_promotion_details',
											e.target.value
										)
									}}
									helperText={`${
										membership.trial_settings?.monthly_promotion_details
											? membership.trial_settings?.monthly_promotion_details.length
											: 0
									} / 15 Max Characters`}
									inputProps={{ maxLength: 15 }}
								/>
							)}
						</Box>
					</Box>

					<Box mb={2}>
						<Title pt={0} fontSize={12} label={'Membership Page Promo Text Box'} />
						<Box className={classes.row}>
							<TextField
								label="Promotion Text Box"
								variant="filled"
								disabled={(isAnnualPromoInactive() && isMonthlyPromoInactive()) || isInactive()}
								multiline={true}
								rows={3}
								value={membership.trial_settings?.promo_text_box}
								onChange={(e) => {
									e.preventDefault()
									updateTrialMembership(membership._id, 'promo_text_box', e.target.value)
								}}
								style={{ marginBottom: 16, width: '66%' }}
								InputProps={{
									inputProps: { maxLength: 250 }
								}}
								helperText={`${
									membership.trial_settings?.promo_text_box
										? membership.trial_settings?.promo_text_box.length
										: 0
								} / 250 Max Characters`}
							/>
						</Box>
					</Box>

					<Box mb={2}>
						<Title pt={0} fontSize={12} label={'DASHBOARD PROMO TEXT'} />
						<Box className={classes.row}>
							<TextField
								label="Dashboard Promo Text"
								variant="filled"
								disabled={(isAnnualPromoInactive() && isMonthlyPromoInactive()) || isInactive()}
								multiline={true}
								rows={2}
								value={membership.trial_settings?.dashboard_promo_text}
								onChange={(e) => {
									e.preventDefault()
									updateTrialMembership(membership._id, 'dashboard_promo_text', e.target.value)
								}}
								style={{ marginBottom: 16, width: '66%' }}
								InputProps={{
									inputProps: { maxLength: 45 }
								}}
								helperText={`${
									membership.trial_settings?.dashboard_promo_text
										? membership.trial_settings?.dashboard_promo_text.length
										: 0
								} / 45 Max Characters`}
							/>
						</Box>
					</Box>
				</CardContent>
			</Collapse>
		</Card>
	)
}

const ListWithAddButton = ({
	title,
	subtitle,
	list, // list of elements with _id
	label,
	onChange,
	onAdd,
	onDelete,
	disabled = false,
	maxCharacters = 100,
	addButtonLabel = 'Add'
}) => {
	const classes = useStyles()
	const theme = useTheme()

	return (
		<Fragment>
			{title && <Title label={title} />}
			{subtitle && <SubTitle label={subtitle} />}
			<Box>
				{!disabled &&
					(list || []).map((element, index) => (
						<Box key={'ListWithAddButton' + index} className={classes.row}>
							<TextField
								className={clsx([classes.input])}
								style={{ width: '95%' }}
								label={label}
								variant="filled"
								required
								value={element}
								onChange={(e, v) => {
									e.preventDefault()
									list[index] = e.target.value
									if (onChange) onChange(list)
								}}
								helperText={`${element.length || 0} / ${maxCharacters} Max Characters`}
								inputProps={{ maxLength: maxCharacters }}
							/>
							<Box style={{ width: '5%' }}>
								<IconButton
									style={{
										color: '#777679'
									}}
									onClick={() => {
										list.splice(index, 1)
										if (onDelete) onDelete(list)
									}}>
									<CancelOutlined style={{ fill: theme.palette.error.main }} />
								</IconButton>
							</Box>
						</Box>
					))}
				<MainButton
					label={addButtonLabel}
					disabled={disabled}
					onClick={() => {
						const perks = list || []
						perks.push('')
						if (onAdd) onAdd(perks)
					}}
					startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
				/>
			</Box>
		</Fragment>
	)
}

export default AdvancedSettings
